<div class="panelOuter" [ngClass]="(panelOuterCssClasses$ | async) || ''" [@routeAnimation]="true" #container>
  <div class="panel d-flex flex-column justify-content-start">
    <div class="panel-heading border border-top-0 border-left-0 border-right-0 d-flex flex-row"
         [ngClass]="(!panelHeaderIsEmpty$ || (panelHeaderIsEmpty$ | async)) && !parsedButtons.length ? 'p-0 invisible' : 'pe-1 py-2'">
      <div class="flex-grow-1 container-fluid pe-2" #panelHeader>
        <ng-content select="[panel-header]"></ng-content>
      </div>
      <div class="btn-group btn-group-sm ps-1">
        <button *ngFor="let b of parsedButtons" type="button" class="btn btn-light px-1 py-0" (click)="emitButtonClick(b)">
          <i *ngIf="b.iconClass" [ngClass]="b.iconClass"></i>
          {{getButtonText(b)}}
        </button>
      </div>
    </div>
    <div class="panel-subheader container-fluid p-2 border border-top-0 border-left-0 border-right-0"
         [hidden]="panelSubheaderContainerIsEmpty$ | async">
      <div #panelSubheaderContainer>
        <ng-content select="[panel-subheader]"></ng-content>
      </div>
    </div>
    <div class="panel-body container-fluid py-3 flex-shrink-1 flex-grow-1" #panelBody>
      <ng-content select="[panel-body]"></ng-content>
    </div>
    <div class="panel-footer container-fluid py-2" #panelFooter [hidden]="panelFooterIsEmpty$ | async">
      <ng-content select="[panel-footer]"></ng-content>
    </div>
  </div>
</div>
